import { useAppStore, bootstrapFromJwt, usePermissionsStore } from '@repletoryreach/sdk-utils/store';
import { safeLocalStorage, safeSessionStorage } from '@repletoryreach/sdk-utils/storage';
import { getConfig } from './config.js';

// W31: impersonation tokens are tab-scoped (sessionStorage) and take
// precedence over the persisted session, so a platform admin viewing a tenant
// in one tab never clobbers a real agent session in another. They are never
// paired with a refresh token.
const IMPERSONATION_KEY = 'rr.impersonation.token';

export function readImpersonationToken(): string | null {
  const r = safeSessionStorage.getRaw(IMPERSONATION_KEY);
  return r.kind === 'ok' ? r.value : null;
}

export function setImpersonationToken(access: string): void {
  safeSessionStorage.setRaw(IMPERSONATION_KEY, access);
  bootstrapFromJwt(access);
}

export function clearImpersonationToken(): void {
  safeSessionStorage.remove(IMPERSONATION_KEY);
}

export function readAccessToken(): string | null {
  const imp = readImpersonationToken();
  if (imp) return imp;
  const fromStore = useAppStore.getState().accessToken;
  if (fromStore) return fromStore;
  const key = getConfig().auth.storageKeys.access;
  const r = safeLocalStorage.getRaw(key);
  return r.kind === 'ok' ? r.value : null;
}

export function readRefreshToken(): string | null {
  const fromStore = useAppStore.getState().refreshToken;
  if (fromStore) return fromStore;
  const key = getConfig().auth.storageKeys.refresh;
  const r = safeLocalStorage.getRaw(key);
  return r.kind === 'ok' ? r.value : null;
}

export function setTokens(access: string, refresh?: string | null): void {
  const cfg = getConfig();
  safeLocalStorage.setRaw(cfg.auth.storageKeys.access, access);
  if (refresh) safeLocalStorage.setRaw(cfg.auth.storageKeys.refresh, refresh);
  bootstrapFromJwt(access);
  if (refresh) useAppStore.getState().setTokens(access, refresh);
}

export function clearTokens(): void {
  const cfg = getConfig();
  safeLocalStorage.remove(cfg.auth.storageKeys.access);
  safeLocalStorage.remove(cfg.auth.storageKeys.refresh);
  useAppStore.getState().clearAuth();
  usePermissionsStore.getState().clear();
}
